<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>Email Authentication</p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap _t-center"  v-bind:class="{_svgAnimation:svgAnimation, _reSendShow:reSendShow}">

                <div class="svg-icon-wrap">
                    <div class="inner _mail"><SvgIconMail /></div>
                    <div class="inner _resend md_kf-resend"><SvgIconResend /></div>
                </div>

                <h3><span>下記メールアドレスに認証メールを<span class="visible">再</span>送信しました。</span></h3>
                <h3>メール内に記載されたURLをクリックし<br>認証を完了させてください。</h3>
                <h3 class="_email"><span>{{ displayEmail }}</span></h3>
                <button class="btn_ghost" style="margin-top: 2rem;" v-on:click="reSendClick()">
                    <div class="inner">
                        <span>認証メール再送信</span>
                        <div class="icon"><SvgIconSend /></div>
                    </div>
                </button>
                <div class="resend-ovl">
                    <div class="inner md_kf-check-mark">
                        <p>認証メール再送信中</p>
                        <SvgIconCheck />
                    </div>
                </div>

            </div>

        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev" v-on:click="$emit('showPrevSwiper')"><span>Back</span></button>
            <a href="mailto:" class="_right"><span>メールソフト起動</span></a>
            <!-- <a href="message:" class="_right"><span>メールソフト起動</span></a> -->
        </div>

    </div>
</div>
</template>

<script>
    //Svg
    import SvgIconMail from '@/components/EndUser/svg/SvgIconMail'
    import SvgIconSend from '@/components/EndUser/svg/SvgIconSend'
    import SvgIconResend from '@/components/EndUser/svg/SvgIconResend'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'

    export default {
        components: {
            SvgIconMail,
            SvgIconSend,
            SvgIconResend,
            SvgIconCheck,
        },
        data() {
            return {
                svgAnimation: false,
                reSendShow: false,
            }
        },
        props: {
            displayEmail: String,
        },
        methods: {
            reSendClick: function () {
                this.svgAnimation = true;
                setTimeout(()=> {
                    this.reSendShow = true;
                }, 600);
                setTimeout(()=> {
                    this.svgAnimation = false;
                }, 3500);
                axios.post(route('registration.send.verification.email'), {
                    form: this.$store.state.verify.form,
                }).then((res) => {
                    this.$store.state.verify.form.login_email  = res.data.email;
                    this.$store.state.verify.form.company_name = res.data.company_name;
                })
            }
        },
    };
</script>